import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { object, string } from 'yup';
import {
  Formik,
  Form,
} from 'formik';
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons/faDoorOpen';

import { useHttpStatus } from '~/commons/hooks';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';

const schema = object().shape({
  username: string()
    .trim()
    .lowercase()
    .required('Required'),
  password: string()
    .required('Required'),
});
const defaults = {
  username: '',
  password: '',
};

const FormLogin = ({
  title = '',
  router = true,
}) => {
  const [persist, setPersist] = useState(true);
  const [res, req] = useHttpStatus({
    onSuccess() {
      window.location.replace('/admin');
    },
    onError(err) {
      const { data } = err.response ?? {};
      if (data === 'Password expired') {
        window.location.replace('/auth/pwd-expired');
      }
    },
  });

  return (
    <>
      <div className="row mb-3">
        <div className="col">{title}</div>
      </div>
      <Formik
        validationSchema={schema}
        initialValues={defaults}
        onSubmit={(values) => req({
          method: 'post',
          url: '/api/core/auth',
          data: {
            ...values,
            web: 1,
            persist,
          },
        })}
      >
        <Form>
          <FormHttpAlert res={res} />
          <FormGroup
            name="username"
            label={null}
            placeholder="Username"
          />
          <FormGroup
            name="password"
            type="password"
            label={null}
            placeholder="Password"
          />
          <div className="row mb-3">
            <div className="col">
              <div className="form-check form-control-sm">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="persist"
                  checked={persist}
                  onChange={() => setPersist(!persist)}
                />
                <label
                  className="form-check-label"
                  htmlFor="persist"
                >
                  Remember me
                </label>
              </div>
            </div>
            <div className="col-auto">
              {router ? (
                <Link to="/auth/pwd-recovery">
                  <small>Forgot password?</small>
                </Link>
              ) : (
                <a href="/auth/pwd-recovery">
                  <small>Forgot password?</small>
                </a>
              )}
            </div>
          </div>
          <div className="form-group text-right">
            <FormHttpBtn
              res={res}
              type="submit"
              className="btn-primary btn-block"
              icon={faDoorOpen}
            >
              Login
            </FormHttpBtn>
          </div>
        </Form>
      </Formik>
    </>
  );
};

export default FormLogin;
